export default "__VITE_ASSET__DueZVIzS4HsGzXaSiwy1Hg__"